
/****************ELEMENTS*****************/
//this obj define, the actions realeted to each 
//th>table header and td

export const tableDetail = {
    entity: 'areas',//name table on the db
    dest: 'areas',//name of the entity on the system

    //action for body 
    //left click, directly to the fullcont 
    tdDataDetail:`data-detail='{ "click": [ {"dest":"ripple" },
                                            {"dest":"areas", "elem":"fullcont", "id":"areas-fullcont", "act":"selectOne", "entity":"areas", "dbid": "#dbid"}  ],
                                
                                 "clickRight": [{"dest":"areas", "elem":"dt", "act":"trMenu", "id":"trMenu",  "entity":"areas", "dbid": "#dbid" } ]  }'`,

    filter: {
        mainFilterFields : ["areas.name","areas.bay","areas.level","areas.space"],
        mainFilterValues : ["", ""],         
        andFilterFields  : [""],
        andFilterValues  : [""],  
    }

}



/****************ELEMENTS*****************/



//each element could organize their data diferent
export function organizeRow(data){ //console.log('organizeRow>')

    var newData = []

    if(data.length === 0){
        newData.push({   id: 'nothing', colum: [{ label:'No Results', span: '' },
                                                { label:'', span:'' },
                                                { label:'', span:'' },
                                                { label:'', span:'' },] })
        return newData
    }

    data.forEach((elem)=>{
        newData.push(
                {   id: elem.id,   colum: [  { label: elem.name },
                                             { label: elem.bay },
                                             { label: elem.level },
                                             { label: elem.space }, ]    
                }
        )/*push*/
    })/*forEach*/

    return newData
}/*organizeRow*/